import React from 'react';
import styled from 'styled-components';
import cashwalk from '../../assets/project/cashwalk_trans.png';

const CashwalkProject = () => {
  return (
    <Container>
      <div className='box'>
        <div className='box-tag'>현재 진행형</div>
        <div className='box-heading'>
          서비스 런칭은 빠르게.
          <br />
          개발은 단단하게.
        </div>
        <div className='box-detail'>
          <div className='box-desc-heading'>
            <div className='box-desc-list'>
              <div className='box-desc-list-item'>
                그룹 걷기 챌린지
                <br />
                서비스
              </div>
              <div className='box-desc-list-item'>
                라이브 방송 광고
                <br />
                서비스
              </div>
              <div className='box-desc-list-item'>
                마음을 다스릴 수 있는 명상
                <br />
                서비스
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  grid-column: span 2;

  .img-box {
    text-align: center;

    img {
      width: 540px;
    }
  }

  .box {
    background-color: #181725;
    border-radius: 25px;
    text-align: left;
    padding: 40px;
    background-image: url('${cashwalk}');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left bottom;
  }

  .box-tag {
    margin-bottom: 40px;
    color: #fff;
    font-size: 19px;
    font-weight: 600;
  }

  .box-heading {
    font-size: 40px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-sub-heading {
    font-size: 64px;
    font-weight: 700;
    margin: 0;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-detail {
    font-size: 19px;

    .box-desc-heading {
      color: #fff;
      margin-bottom: 8px;
    }

    .box-description {
      margin: 0;
    }

    .box-desc-list {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      justify-content: space-evenly;
      margin-top: 48px;
      font-size: 36px;
      font-weight: 700;

      .box-desc-list-item {
        padding: 12px 18px;
        text-align: center;
      }
    }
  }

  @media only screen and (min-width: 769px) {
    .box-detail {
      .box-desc-list {
        font-size: 56px;
      }
    }
  }
`;

export default CashwalkProject;
